import type { UseCase } from '../../_kernel/architecture'
import type { Promotion } from '../domain/Promotion'
import type { Config } from '../../_config'

import type { MarketingRepository } from '../infrastructure/MarketingRepository'
import GetCurrentMarketSharedUseCase from '../../shared/application/GetCurrentMarketSharedUseCase'
import GetCurrentLanguageSharedUseCase from '../../shared/application/GetCurrentLanguageSharedUseCase'
import { HTTPMarketingRepository } from '../infrastructure/HTTPMarketingRepository'

export default class GetCurrentPromoMarketingUseCase implements UseCase<undefined, Promotion> {
  static readonly USE_CASE_NAME = 'GetPromoBySlugMarketingUseCase'
  static create({
    config,
    repository,
    marketUseCase,
    languageUseCase,
  }: {
    config: Config
    repository?: MarketingRepository
    marketUseCase?: GetCurrentMarketSharedUseCase
    languageUseCase?: GetCurrentLanguageSharedUseCase
  }) {
    return new GetCurrentPromoMarketingUseCase(
      repository ?? HTTPMarketingRepository.create({ config }),
      marketUseCase ?? GetCurrentMarketSharedUseCase.create({ config }),
      languageUseCase ?? GetCurrentLanguageSharedUseCase.create({ config })
    )
  }

  constructor(
    private readonly repository: MarketingRepository,
    private readonly getCurrentMarketUseCase: GetCurrentMarketSharedUseCase,
    private readonly getCurrentLanguageUseCase: GetCurrentLanguageSharedUseCase
  ) {}

  async execute() {
    const [market, language] = await Promise.all([
      await this.getCurrentMarketUseCase.execute(),
      await this.getCurrentLanguageUseCase.execute(),
    ])

    const promotions = await this.repository.getActivePromotions({ market, language })

    return promotions.getFirstOrEmpty()
  }
}
